import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import {
  Button,
  Flex,
  Input,
  PaginationProps,
  Spin,
  Table,
  TableColumnsType,
} from "antd";
import { Copy, Home2, SearchZoomIn1 } from "iconsax-react";
import MetricItem from "../Report/Components/MetricItem";
import "./DashboardAdmin.css";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { mixPostV1 } from "../../services/mixin";
import { pencil } from "../Report/Staff";
import DasTotalStoreModal from "./Component/DasTotalStoreModal";

interface DataType {
  key: React.Key;
  sellerName: string;
  sellerId: number;
  phoneNumber: string;
  email: string;
  statusLock: number;
  id: number;
  total_active_store: number;
  total_overdue_store: number;
  total_store: number;
  total_unactive_store: number;
}
const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};
const DashboardAdmin: React.FC = () => {
  const [showDasTotalStoreModal, setShowDasTotalStoreModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [typeStore, setTypeStore] = useState<number>(0);
  const [metrics, setMetrics] = useState({
    total_active_store: 0,
    total_overdue_store: 0,
    total_store: 0,
    total_unactive_store: 0,
    total_reject_store: 0,
  });
  const columns: TableColumnsType<DataType> = [
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params.page_number - 1) * params.limit + index + 1,
    },
    {
      title: "Seller ID",
      dataIndex: "sellerId",
      key: "sellerId",
    },
    {
      title: "Seller name",
      dataIndex: "sellerName",
      key: "sellerName",
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Total store",
      dataIndex: "total_store",
      key: "total_store",
    },
    {
      title: "Active stores",
      dataIndex: "total_active_store",
      key: "total_active_store",
    },
    {
      title: "Inactive stores",
      dataIndex: "total_unactive_store",
      key: "total_unactive_store",
    },
    {
      title: "Overdue stores",
      dataIndex: "total_overdue_store",
      key: "total_overdue_store",
    },
  ];

  // GET SELLERS
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState({
    limit: 10,
    page_number: 1,
    searchKey: "",
  });

  const getMetrics = async () => {
    setLoading(true);
    const res = await mixPostV1(
      "/api/webAdmin/gTotalStoreDashboardAdmin.php",
      {},
    );

    if (res.status === 1) {
      setMetrics({
        total_active_store: res?.data?.total_active_store ?? 0,
        total_overdue_store: res?.data?.total_overdue_store ?? 0,
        total_store: res?.data?.total_store ?? 0,
        total_unactive_store: res?.data?.total_unactive_store ?? 0,
        total_reject_store: res?.data?.total_reject_store ?? 0,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    getMetrics();
  }, []);
  const getItems = async () => {
    setTableLoading(true);
    const res = await mixPostV1(
      "/api/webAdmin/gListAccountSellerDashboard.php",
      params,
    );

    if (res.status === 1) {
      const result: any = [];
      res.data.map((item: any) =>
        result.push({
          ...item,
          key: item.id,
          sellerId: item.id,
          sellerName: item.owner_name,
          phoneNumber: item.phone_number,
          email: item.email,
          statusLock: item.is_locked,
          total_active_store: item.total_active_store,
          total_overdue_store: item.total_overdue_store,
          total_store: item.total_store,
          total_unactive_store: item.total_unactive_store,
        }),
      );
      setItems({
        ...items,
        list: result,
        total: res.total,
      });
      setTableLoading(false);
    }
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };

  const onSearch = (e: any) => {
    setParams({
      ...params,
      page_number: 1,
      searchKey: e.target.value,
    });
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e);
    }, 250);
    setSearchTimeout(timeout);
  };
  return (
    <>
      <Layout contentClassName="store-list-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/dashboard-admin">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Dashboard Admin" },
          ]}
          title="Dashboard Admin"
          description=""
        />

        <Spin spinning={loading}>
          <div className="dashboard-admin-metrics">
            <MetricItem
              title="Total stores"
              quantity={metrics.total_store}
              onClick={() => {
                setTypeStore(0);
                setShowDasTotalStoreModal(true);
              }}
            />
            <MetricItem
              title="Active stores"
              quantity={metrics.total_active_store}
              onClick={() => {
                setTypeStore(1);
                setParams({
                  ...params,
                  page_number: 1,
                });
                setShowDasTotalStoreModal(true);
              }}
            />
            <MetricItem
              title="Inactive stores"
              quantity={metrics.total_unactive_store}
              onClick={() => {
                setParams({
                  ...params,
                  page_number: 1,
                });
                setTypeStore(2);
                setShowDasTotalStoreModal(true);
              }}
            />
            <MetricItem
              title="Overdue stores"
              quantity={metrics.total_overdue_store}
              onClick={() => {
                setParams({
                  ...params,
                  page_number: 1,
                });
                setTypeStore(3);
                setShowDasTotalStoreModal(true);
              }}
            />
            <MetricItem
              title="Reject stores"
              quantity={metrics.total_reject_store}
              onClick={() => {
                setParams({
                  ...params,
                  page_number: 1,
                });
                setTypeStore(4);
                setShowDasTotalStoreModal(true);
              }}
            />
          </div>
        </Spin>
        <div className="table-filter-block">
          <Input
            placeholder="Search by phone number, name"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            allowClear
            className="rs-input table-filter-block__search"
            onChange={(e) => onChange(e)}
            onPressEnter={(e) => onSearch(e)}
          />

          {/* <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button"
            onClick={getItemsByExcel}
          >
            Export
          </Button> */}
        </div>

        <Table
          columns={columns}
          dataSource={items.list}
          className="rs-table table-text-nowrap match-height"
          loading={tableLoading}
          scroll={{
            x: true,
          }}
          pagination={{
            current: params.page_number,
            pageSize: params.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            total: items.total,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange(e),
          }}
          onChange={onTableChange}
        />
      </Layout>
      <DasTotalStoreModal
        isShow={showDasTotalStoreModal}
        onPopupClose={() => setShowDasTotalStoreModal(false)}
        typeStore={typeStore}
      />
    </>
  );
};

export default DashboardAdmin;

